import { Flex } from 'foundations-components/components/Flex';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { jsx as _jsx } from "react/jsx-runtime";
export const TestIds = {
  LOADING_SPINNER: 'loading-spinner'
};
export const GenericLoadingState = () => {
  return /*#__PURE__*/_jsx(Flex, {
    flexGrow: 1,
    alignItems: "center",
    justifyContent: "center",
    children: /*#__PURE__*/_jsx(LoadingSpinner, {
      margin: "0",
      size: "extra-small",
      "data-test-id": TestIds.LOADING_SPINNER
    })
  });
};